import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuditService } from 'app/audit/services/audit.service';

@Component({
    selector: 'app-add-audit-type',
    templateUrl: './add-audit-type.component.html',
    styleUrls: ['./add-audit-type.component.css']
})
export class AddAuditTypeComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    submitAttempt: boolean = false;
    addAddAuditTypeFormGroup: FormGroup;

    constructor(
        private auditService: AuditService,
        private fb: FormBuilder,
		private location: Location,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Audit Type', breadcrumbs: [
                { title: 'Audit Types', url: ['/audit/audittype'] }
            ]
        }
        this.initializeForm();
    }

    initializeForm(): void {
        this.addAddAuditTypeFormGroup = this.fb.group(
            {
                name: ['', Validators.required]
            }
        );
    }

    addAuditType(): void {
        this.submitAttempt = true;
        if (this.addAddAuditTypeFormGroup.valid) {
            const formValue = this.addAddAuditTypeFormGroup.value;
            this.auditService.createAuditType(formValue).subscribe(
                companyId => {
                    this.router.navigate(['./audit/audittype']);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }
}
